<div class="bciti-table">
  <table 
    class="table" 
    #serviceTable 
    mat-table 
    [dataSource]="dataSource" 
    cdkDropList
    (cdkDropListDropped)="drop($event)"
  >

    <!-- Name -->
    <ng-container matColumnDef="name">
      <th class="table-header" mat-header-cell *matHeaderCellDef>{{ 'pages.services-state.list.table.header.serviceName' | translate }}</th>
      <td class="table-name" mat-cell *matCellDef="let element" (click)="handleClick('edit', element)">
        <span>
          {{ element.name[currentLang] }}
        </span>
      </td>
    </ng-container>

    <!-- Category -->
    <ng-container matColumnDef="category">
      <th class="table-header" mat-header-cell *matHeaderCellDef>{{ 'pages.services-state.list.table.header.category' | translate }}</th>
      <td class="table-category" mat-cell *matCellDef="let element">
        {{ element.category.name[currentLang] }}
      </td>
    </ng-container>

    <!-- Starred -->
    <ng-container matColumnDef="starred">
      <th class="table-header" mat-header-cell *matHeaderCellDef>{{ 'pages.services-state.list.table.header.starred' | translate }}</th>
      <td class="table-checkbox" mat-cell *matCellDef="let element">
        <app-form-checkbox
          #starredCheckbox
          class="checkbox" 
          [isChecked]="element.starred"
          [showMessages]="false"
          [displayTouchedStyle]="false"
          (change)="handleStarred($event, element)"
        ></app-form-checkbox>
      </td>
    </ng-container>

    <!-- Schedule -->
    <ng-container matColumnDef="schedule">
      <th class="table-header" mat-header-cell *matHeaderCellDef>{{ 'pages.services-state.list.table.header.schedule' | translate }}</th>
      <td class="table-schedule" mat-cell *matCellDef="let element">
        <div class="cell-schedule">
          <!-- Regular  -->
          <button 
            class="desktop-table-button bciti-button bciti-button--invisible" 
            aria-label="Open"
            [matMenuTriggerFor]="scheduleMenu"
          >
            <span *ngIf="element.regularSchedule">
              {{ 'common.regular' | translate }}
            </span>
            <span *ngIf="!element.regularSchedule" [style.color]="element.currentStatus.color">
              {{ element.currentStatus.name[currentLang] }}
            </span>
            <span class="icon-caret-down"></span>
          </button>
          <mat-menu 
            #scheduleMenu="matMenu" 
            class="bciti-table-dropdown bciti-table-dropdown--schedule"
            xPosition="before"
          >
            <button
              *ngIf="!element.regularSchedule"
              mat-menu-item
              class="bciti-table-dropdown-option"
              (click)="handleClick('override-end', element)"
            >
              <span>{{ 'pages.services-state.list.table.action-menu.back-to-regular' | translate }} </span>
            </button>
            <button
              mat-menu-item
              class="bciti-table-dropdown-option"
              (click)="handleClick('open-status', element)"
            >
              <span [style.color]="element.availableStatus.color">{{ element.availableStatus.name[currentLang] }}</span>
            </button>
            <button 
              mat-menu-item
              class="bciti-table-dropdown-option"
              (click)="handleClick('close-status', element)"
            >
              <span [style.color]="element.nonAvailableStatus.color">{{ element.nonAvailableStatus.name[currentLang] }} </span>
            </button>
          </mat-menu>
        </div>
      </td>
    </ng-container>

    <!-- Action -->
    <ng-container matColumnDef="action">
      <th class="table-header" mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element" class="action-col">
        <button 
          class="desktop-table-button bciti-button bciti-button--invisible" 
          aria-label="Open"
          [matMenuTriggerFor]="actionMenu"
        >
          <i class="icon-more-vertical"></i>
        </button>
        <mat-menu 
          #actionMenu="matMenu" 
          class="bciti-table-dropdown bciti-table-dropdown--actions" 
          xPosition="before"
        >
          <button 
            mat-menu-item
            *ngFor="let item of actionMenuOptions"
            class="bciti-table-dropdown-option bciti-table-dropdown-option--actions"
            (click)="handleClick(item.eventEmitterTag, element)"
          >
            <span>{{ item.label }}</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnKeys"></tr>
    <tr 
      *matRowDef="let row; columns: columnKeys; let rowIndex = index" 
      mat-row 
      cdkDrag 
      cdkDragLockAxis="y"
      [cdkDragPreviewClass]="getBackgroundPreviewDropColor(rowIndex)"
      class="grabbable"
    ></tr>

    <tr class="mat-row" *matNoDataRow>
      <td
        class="mat-cell"
        [attr.colspan]="columnKeys.length"
      >
        <div class="empty-table-cell-content">
          <mat-progress-spinner
            *ngIf="loading"
            mode="indeterminate" 
            diameter="20"
          ></mat-progress-spinner>
          <span *ngIf="!loading">
            No services
          </span>
        </div>
      </td>
    </tr>

    <div *cdkDragPlaceholder></div>

  </table>

  <mat-paginator 
    class="paginator"
    showFirstLastButtons 
    [length]="dataSource.data.length"
    [pageSizeOptions]="[5, 10, 25, 50]" 
    [pageSize]="10"
  ></mat-paginator>
</div>